import { Button } from "@mui/material";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getFormPrestaciones } from "../../../../actions/forms";
import { StyledPrestacionesContainer } from "../../../styled/form";
import PrestacionesAdd from "./prestacionesAdd";
import PrestacionesCard from "./prestacionesCard";

const prestacionModel = {
  id: null,
  cantidad: 1,
  zonaAfectada: null,
  subnomenclador: null,
};

const PrestacionesContainer = ({
  prestaciones,
  setPrestaciones,
  disabled,
  configuration,
  idArt,
  name,
}) => {
  const dispatch = useDispatch();

  const [openAdd, setOpenAdd] = useState(false);

  const prestacionesState = useSelector((state) => state.forms.prestaciones);

  const maxPrestaciones =
    configuration.maxAmountOfPrestaciones !== 0 &&
    prestaciones.length >= configuration.maxAmountOfPrestaciones;

  const minPrestaciones =
    configuration.minAmountOfPrestaciones !== 0 &&
    prestaciones.length < configuration.minAmountOfPrestaciones;

  const handleAdd = (value) => {
    let prestacionExisted = prestaciones.find(
      (p) => p.id === value.id && p.zonaAfectada === value.zonaAfectada,
    );

    if (!prestacionExisted) {
      prestaciones.push(value);
    } else {
      prestacionExisted.cantidad = value.cantidad;
    }
    handleCloseAdd();
  };

  const handleDelete = (prestacion) => {
    setPrestaciones(
      prestaciones.filter(
        (p) =>
          p.id !== prestacion.id || p.zonaAfectada !== prestacion.zonaAfectada,
      ),
    );
  };

  const handleOpenAdd = () => {
    if (!prestacionesState.data.prestaciones && !prestacionesState.isFetching) {
      dispatch(getFormPrestaciones(idArt));
    }
    setOpenAdd(true);
  };

  const handleCloseAdd = () => {
    setOpenAdd(false);
  };

  return (
    <StyledPrestacionesContainer.Container>
      <PrestacionesCard
        prestaciones={prestaciones}
        disabled={disabled}
        handleDelete={handleDelete}
      />
      {maxPrestaciones && (
        <StyledPrestacionesContainer.PrestacionesErrorText
          variant="body2"
          color="error">
          Se alcanzó el límite de Prestaciones por formulario para esta ART
        </StyledPrestacionesContainer.PrestacionesErrorText>
      )}
      {minPrestaciones && (
        <StyledPrestacionesContainer.PrestacionesErrorText
          variant="body2"
          color="error">
          {`Debe ingresar al menos ${configuration.minAmountOfPrestaciones}  ${configuration.minAmountOfPrestaciones > 1
            ? "prestaciones"
            : "prestación"
            }`}
        </StyledPrestacionesContainer.PrestacionesErrorText>
      )}
      <Button
        name={name}
        color="primary"
        variant="outlined"
        onClick={handleOpenAdd}
        disabled={disabled || maxPrestaciones}>
        Agregar prestación
      </Button>
      <PrestacionesAdd
        prestacion={prestacionModel}
        open={openAdd}
        handleClose={handleCloseAdd}
        handleSubmit={handleAdd}
      />
    </StyledPrestacionesContainer.Container>
  );
};

export default PrestacionesContainer;
